
function processStore2(store, action) {
    if (!store.reducer) {
        console.error('Store nemá definovanou metodu reducer', store, action);
    }
    return store.reducer(store, action);
}

export default class StoreUtils {
    static consolidateState(prevState, newState) {
        return StoreUtils.stateEquals(prevState, newState) ? prevState : newState;
    }

    static processStore(name, state, action) {
        return {
            ...state,
            [name]: processStore2(state[name], action),
        };
    }

    static processAllStores(state, action) {
        const result = {...state};
        Object.keys(state).forEach((key) => {
            if (state[key].reducer) {
                result[key] = processStore2(state[key], action);
            }
        });
        return result;
    }

    static propsEquals(x, y, attrs) {
        if (typeof attrs !== 'undefined' && attrs !== null) {
            for (let a = 0; a < attrs.length; a++) {
                const p = attrs[a];

                if (!x.hasOwnProperty(p)) { continue; }
                // other properties were tested using x.constructor === y.constructor

                if (!y.hasOwnProperty(p)) {
                    return false;
                }
                // allows to compare x[ p ] and y[ p ] when set to undefined

                if (x[p] === y[p]) { continue; }
                // if they have the same strict value or identity then they are equal

                if (typeof( x[p] ) !== 'object') {
                    return false;
                }
                // Numbers, Strings, Functions, Booleans must be strictly equal

                if (x[p] !== y[p]) {
                    return false;
                }
            }
            return true;
        } else {
            return StoreUtils.stateEquals(x, y);
        }
    }

    static stateEquals(x, y) {
        for (const p in x) {
            if (!x.hasOwnProperty(p)) { continue; }
            // other properties were tested using x.constructor === y.constructor

            if (!y.hasOwnProperty(p)) { return false; }
            // allows to compare x[ p ] and y[ p ] when set to undefined

            if (x[p] === y[p]) { continue; }
            // if they have the same strict value or identity then they are equal

            if (typeof( x[p] ) !== 'object') { return false; }
            // Numbers, Strings, Functions, Booleans must be strictly equal

            if (x[p] !== y[p]) {
//console.log(p)
                return false;
            }
        }
        return true;
    }

    static objectEquals(x, y) {
        if (x === null || x === undefined || y === null || y === undefined) {
            return x === y;
        }
        // after this just checking type of one would be enough
        if (x.constructor !== y.constructor) {
            return false;
        }
        // if they are functions, they should exactly refer to same one (because of closures)
        if (x instanceof Function) {
            return x === y;
        }
        // if they are regexps, they should exactly refer to same one (it is hard to better equality check on current ES)
        if (x instanceof RegExp) {
            return x === y;
        }
        if (x === y || x.valueOf() === y.valueOf()) {
            return true;
        }
        if (Array.isArray(x) && x.length !== y.length) {
            return false;
        }

        // if they are dates, they must had equal valueOf
        if (x instanceof Date) {
            return false;
        }

        // if they are strictly equal, they both need to be object at least
        if (!(x instanceof Object)) {
            return false;
        }
        if (!(y instanceof Object)) {
            return false;
        }

        // recursive object equality check
        const p = Object.keys(x);
        return Object.keys(y).every(function (i) {
                return p.indexOf(i) !== -1;
            }) &&
            p.every(function (i) {
                return StoreUtils.objectEquals(x[i], y[i]);
            });
    }
}
